import React from 'react';
import useStyles from './styles';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

const Loading = ({ loadingIndicatorSize, label }: LoadingProps) => {
  const { classes } = useStyles();

  return (
    <div className={classes.loadingContainer}>
      <CircularProgress size={loadingIndicatorSize} color={'primary'} />
      {label && <Typography className={classes.loadingLabel}>{label}</Typography>}
    </div>
  );
};

export type LoadingProps = {
  loadingIndicatorSize?: number | string;
  label?: string;
};

export default Loading;
